import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import TalismanHand from './TalismanHand';
import { Text } from '@talismn/ui';
const ErrorMessage = Object.assign((props) => (_jsxs("article", { css: [
        { display: 'flex', alignItems: 'center', gap: '1.6rem' },
        props.orientation === 'horizontal' ? {} : { flexDirection: 'column', textAlign: 'center' },
    ], children: [_jsx("figure", { css: { margin: 0 }, children: _jsx(TalismanHand, { width: props.orientation === 'horizontal' ? '6rem' : '10rem', height: props.orientation === 'horizontal' ? '6rem' : '10rem' }) }), _jsxs("div", { css: [
                { display: 'flex', flexDirection: 'column' },
                props.orientation === 'horizontal'
                    ? { flexDirection: 'row', gap: '0.8rem' }
                    : { alignItems: 'center', gap: '1.6rem' },
            ], children: [_jsxs("div", { children: [_jsx(Text.BodyLarge, { as: "header", alpha: "high", children: props.title }), _jsx(Text.BodySmall, { children: props.message })] }), props.actions] })] })), {
    Actions: (props) => (_jsx("div", { ...props, css: { display: 'flex', alignItems: 'center', gap: '0.8rem' } })),
});
export default ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map